import {RSAA} from "redux-api-middleware";
import queryParser from "../../utils/queryParser";
import headers from "../../utils/headers";

export const TRUST_ID_LOGS_INDEX_REQUEST = "TRUST_ID_LOGS_INDEX_REQUEST";
export const TRUST_ID_LOGS_INDEX_SUCCESS = "TRUST_ID_LOGS_INDEX_SUCCESS";
export const TRUST_ID_LOGS_INDEX_ERROR = "TRUST_ID_LOGS_INDEX_ERROR";

export const TRUST_ID_REPORT_REQUEST = "TRUST_ID_REPORT_REQUEST";
export const TRUST_ID_REPORT_SUCCESS = "TRUST_ID_REPORT_SUCCESS";
export const TRUST_ID_REPORT_ERROR = "TRUST_ID_REPORT_ERROR";

export const SMS_FALLBACK_LOGS_INDEX_REQUEST = "SMS_FALLBACK_LOGS_INDEX_REQUEST";
export const SMS_FALLBACK_LOGS_INDEX_SUCCESS = "SMS_FALLBACK_LOGS_INDEX_SUCCESS";
export const SMS_FALLBACK_LOGS_INDEX_ERROR = "SMS_FALLBACK_LOGS_INDEX_ERROR";

export function logIndexAction(endpoint, types) {
    return (queries = {}) => ({
        [RSAA]: {
            endpoint: () => {
                const params = {...queries};
                if (params.limit === undefined) params.limit = 10;
                if (params.page === undefined) params.page = 1;
                return `${endpoint}?${queryParser(params)}`;
            },
            method: "GET",
            headers: headers(),
            types: [
                types.request,
                {
                    type: types.success,
                    payload: async (action, state, res) => {
                        const json = await res.json();
                        return {
                            type: types.success,
                            data: json.data || {},
                            message: json.message || "",
                        };
                    },
                },
                {
                    type: types.error,
                    payload: (action, state, res) => res.json(),
                },
            ],
        },
    });
}
